// Query shape for order lists rendered through CustomerOrderItem. Shared by the customer
// orders drawer and the customer summary's last-order card so the component always gets the
// relationships it dereferences: shipments and their tags for the status pills,
// line_items.item for title and colour, market for the code, customer because
// showOrderPreview() reads it, attachments because awaitingPayment() does.
export const ORDER_LIST_INCLUDES = [
  'line_items.item',
  'line_items.return_line_items.return',
  'shipments',
  'shipments.line_items.item',
  'shipments.line_items.return_line_items.return',
  'shipments.tags',
  'shipments.shipping_method',
  'customer',
  'market',
  'tags',
  'attachments'
]

export const ORDER_LIST_FIELDS = {
  orders: [
    'status',
    'number',
    'approved_at',
    'placed_at',
    'metadata',
    'total_amount_float',
    'payment_status',
    'shipments',
    'line_items',
    'fulfillment_status',
    'currency_code',
    'customer',
    'market',
    'tags',
    'attachments',
    'order_copies'
  ],
  line_items: [
    'sku_code',
    'item_type',
    'image_url',
    'metadata',
    'item',
    'reference',
    'return_line_items',
    // getVisibleItems() gates gift cards on total_amount_cents > 0, so leaving this out hides
    // them entirely rather than showing them at zero.
    'total_amount_cents'
  ],
  shipments: [
    'line_items',
    'status',
    'number',
    'tags',
    'shipping_method',
    'metadata',
    'reference_origin'
  ],
  shipping_method: ['reference'],
  customers: ['metadata'],
  markets: ['code'],
  // code is what a gift card line item displays in place of a colour.
  skus: ['metadata', 'code'],
  return_line_items: ['return'],
  returns: ['reference', 'status'],
  attachments: ['reference_origin']
}
